"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = require("@material-ui/core/styles");
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
const useStyles = (0, _styles.makeStyles)(theme => (0, _styles.createStyles)({
  searchButton: {
    width: 54,
    height: 54,
    backgroundColor: _episourceColor["default"].textContrast,
    border: "solid 1px",
    borderColor: _episourceColor["default"].divider,
    marginRight: 12
  },
  searchButtonClose: {}
}));
const SearchButton = _ref => {
  let {
    isSearchVisible,
    onSearchButtonClick
  } = _ref;
  const classes = useStyles({});
  return /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    className: (0, _clsx["default"])(classes.searchButton, {
      [classes.searchButtonClose]: isSearchVisible
    }),
    color: "inherit",
    "aria-label": "search-button",
    onClick: onSearchButtonClick
  }, !isSearchVisible && /*#__PURE__*/_react["default"].createElement(_icons.Search, null), isSearchVisible && /*#__PURE__*/_react["default"].createElement(_icons.Close, null));
};
var _default = SearchButton;
exports["default"] = _default;